import React from 'react';
import useFileList from '../../hooks/useFileList';
import FileItem from './FileItem';
import StorageBar from '../Storage/StorageBar';
import './FileList.css';

function FileList() {
  const {
    user,
    transcripts,
    loading,
    error,
    loadFiles,
    handleDelete,
  } = useFileList();

  if (loading) {
    return (
      <div className="file-list-container">
        <h1 className="file-list-title">My Files</h1>
        <div className="loading">Loading files...</div>
      </div>
    );
  }

  return (
    <div className="file-list-container">
      <div className="file-list-header">
        <h1 className="file-list-title">My Files</h1>
        <button className="btn btn-secondary" onClick={loadFiles}>
          Refresh
        </button>
      </div>

      <StorageBar storage={user?.storage} />

      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}

      {transcripts.length === 0 ? (
        <div className="file-list-empty card">
          <p>No files yet. Upload a file to get started.</p>
        </div>
      ) : (
        <div className="file-list">
          {transcripts.map((transcript) => (
            <FileItem
              key={transcript.id}
              transcript={transcript}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default FileList;
